<template>
  <HomePhone v-if="isphone"></HomePhone>
  <div id="home" v-else v-loading="loading">
    <div id='md0'>
      <img id='m0bg' :src='m0bg'/>
      <div class="ifr">
        <img id='logo' width="278px" height="103px" :class="iscn?'':'logoen'" :src="iscn?logo:logo_en"/>
        <label id='title'>{{lan.title}}</label>
        <el-popover
          id='langfr'
          placement="bottom"
          width="160"
          trigger="click">
          <div @click="changLang('cn')" class='langit'>
            <img :src="md0icn" />
            简体中文
            <img v-if="iscn" :src="md0lanck" class="md0check" />
          </div>
          <div @click="changLang('en')" class='langit'>
            <img :src="md0ien" />
            English
            <img v-if="!iscn" :src="md0lanck" class="md0check" />
          </div>
          <img style="cursor:pointer;width:31px" slot="reference" :src='langic' />
        </el-popover>
        <el-row style="margin-top:108px">
          <el-col :span="12" style="margin-top:10px;">
            <div id='md0title'>
              Digital Twin Platform for Site Management
            </div>
            <div id='md0subt' v-if="iscn">
              JARVIS 360鹰眼<br/>
              数字化智慧工地监管系统
            </div>
          </el-col>
          <el-col :span="12" style="text-align:right;">
            <img :src='pc'/>
          </el-col>
        </el-row>
        <div id='md0sp'>1111111111111111</div>
        <img id='md0btm' :src="iscn?md0desc:md0desc_en" />
      </div>
    </div>
    <div id='md1'>
      <!-- <img id='md1bg0' :src='md1bg0'/>
      <img id='md1bg1' :src='md1bg1'/>         -->
      <div class="ifr">
        <img id='md1bg0' :src='md1bg0'/>
        <img id='md1bg1' :src='md1bg1'/>
        <div class="md1cfr" >
          <div id='md1tt' >{{lan.md1title}}</div>
          <div id='md1st' >{{iscn?'Connect you and remote site seamlessly':''}}</div>
          <div id='md1c0' class='md1fr'>
            <div>
              <img :src='md1i0' class='md1imgsz' />
              <div :class="iscn?'':'enfs20'">{{lan.md1c0title}}</div>
              <img :src='md1ib'/>
              <label :class="iscn?'':'enfs16'">{{lan.md1c0desc}}</label>
            </div>
          </div>
        </div>
        <div class='md1cfr' style="margin-left:496px;">
          <div id='md1c1' :class="iscn?'md1fr':'md1fr enw308'">
            <div>
              <img :src='md1i1' class='md1imgsz' />
              <div>{{lan.md1c1title}}</div>
              <img :src='md1ib'/>
              <label :class="iscn?'':'enfs16'">{{lan.md1c1desc}}</label>
            </div>
          </div>
          <div id='md1c2' :class="iscn?'md1fr':'enw380 md1fr enmt8'">
            <div>
              <img :src='md1i2' class="md1imgsz"/>
              <div :class="iscn?'':'enfs20'">{{lan.md1c2title}}</div>
              <img :src='md1ib'/>
              <label :class="iscn?'':'enfs16'">{{lan.md1c2desc}}</label>
            </div>
          </div>
          <div id='md1c3' :class="iscn?'md1fr':'enw608 md1fr'">
            <div>
              <img :src='md1i3' class="md1imgsz"/>
              <div>{{lan.md1c3title}}</div>
              <img :src='md1ib'/>
              <label :class="iscn?'':'enfs16'">{{lan.md1c3desc}}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id='md2'>
      <img :src="iscn?md2img:md2img_en"/>
    </div>
    <div id='md3'>
      <div v-if='iscn'>让你<label><b>巨细无遗</b></label>检视工程的每一个细节</div>
      <div v-else><b>Capture the work in 3DVR</b></div>
      <div>{{lan.md3desc}}</div>
      <img :src='md3img' />
    </div>
    <div id='md4'>
      <div>{{lan.md4title}}</div>
      <div :class="iscn?'':'enfs22'">{{lan.md4desc}}</div>
      <img :src='md4img0'/>
      <img :src="iscn?md4img1:md4img1_en"/>
    </div>
    <div id='md5'>
      <div class="ifr ">
        <div id='md5a'>
          <div id='md5att'><b>{{lan.md5title}}</b></div>
          <div id='md5ast' v-if='iscn'>Connect project past and future</div>


          <div id='md5apl'>
            <div id='md5adesc'>
              {{md5awds[md5asl]}}
            </div>
            <el-carousel height="466px" indicator-position="outside" @change="cardChange">
              <el-carousel-item v-for="item in md5as" :key="item">
                <img :src="item" />
              </el-carousel-item>
            </el-carousel>
          </div>
          <!-- org  -->

          <!-- org  -->
        </div>
        <div id='md5b'>
          <div :style="'margin-top:-'+tpmg+'px;'">
            <img v-for="img in md5bs" :key="img" :src="img" />
          </div>
          <div>
            <img v-for="img in md5bs" :key="img" :src="img" />
          </div>
        </div>
      </div>
    </div>
    <div id='md6'>
      <div class="ifr">
        <img id='md6bg' :src="iscn?md6abg:md6abg_en"/>
        <div id='md6a'>
          <div>{{lan.md6title}}</div>
          <label>{{lan.md6desc}}</label>
        </div>
        <div id='md6b'>
          <div class="md6bfr">
            <img class="md6bimgsz " :src='md6b0' />
            <div class="pd22">{{lan.md6c0title}}</div>
            <img class="pd22" :src='md6bid1' />
            <label class="pd22">{{lan.md6c0desc}}</label>
          </div>
          <div class="md6bfr">
            <img class="md6bidsz" :src="md6bid0" />
          </div>
          <div class="md6bfr">
            <img class="md6bimgsz" :src='md6b1' />
            <div class="pd22">{{lan.md6c1title}}</div>
            <img class="pd22" :src='md6bid1' />
            <label class="pd22">{{lan.md6c1desc}}</label>
          </div>
          <div class="md6bfr">
            <img class="md6bidsz" :src="md6bid0" />
          </div>
          <div class="md6bfr">
            <img class="md6bimgsz" :src='md6b2' />
            <div class="pd22">{{lan.md6c2title}}</div>
            <img class="pd22" :src='md6bid1' />
            <label class="pd22">{{lan.md6c2desc}}</label>
          </div>
        </div>
      </div>
      <div id='md6c'>
        <img id='md6clg0' :src="iscn?logo:logo_en"/>
        <div id='md6cdesc' :class="iscn?'':'enml0'">{{lan.title}}</div>
      </div>
    </div>
    <div id='md6d'>
<!--      <div class="ifr">-->
<!--        <div id='md6cct'>-->
<!--          <img :src="md6cbg1"/>-->
<!--          <div>-->
<!--            <label>isBIM Limited</label>-->
<!--            <label>{{lan.md6ctaddr}}</label>-->
<!--            <label>{{lan.md6cttel}}</label>-->
<!--            <label>{{lan.md6ctemail}}</label>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <div id='md6carr'><a style="text-decoration: none;color: #D6DBE8;" target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">Copyright ©2016 - {{ new Date().getFullYear() }} JARVIS 深圳前海贾维斯旗下产品 | 粤ICP备18051825号</a></div>
    </div>
  </div>
</template>

<style>
  #home {
    background: white;
    text-align: center;
    overflow: hidden;
    min-width: 1200px;
  }
  .ifr {
    width: 1200px;
    margin: 0 auto;
    background: none;
    text-align: left;
    position: relative;
  }
  #md0 {
    background: #0C1028;
    position: relative;
    overflow: hidden;
  }
  #logo {
    margin-top: 18px;
    margin-left: -38px;
  }
  .logoen {
    width: 278px
  }

  #title {
    position: absolute;
    color: white;
    right: 63px;
    top: 90px;
    font-size: 22px;
    font-weight: bold;
  }
  #langfr {
    position: absolute;
    right: 0px;
    top: 90px;
  }
  .langit img {
    width: 16px;
    margin-right: 8px;
  }

  .md0check {
    float:right;
    margin-top:12px
  }
  .langit {
    font-size: 14px;
    color: #FFFFFF;
    height: 38px;
    line-height: 38px;
    cursor: pointer;
  }
  .el-popover {
    background: black !important;
    border:none;
  }
  .popper__arrow::after {
    border-bottom-color: black !important;
    top: 0px !important;
  }
  #md0title {
    width: 535px;
    height: 142px;
    color: white;
    font-size: 48px;
    font-weight: bold;
  }
  #md0subt {
    font-size: 32px;
    color: white;
    margin-top: 30px;
  }
  #m0bg {
    position: absolute;
    display: block;
    right: -120px;
  }
  #md0sp {
    display: block;
    margin-top: 102px;
    margin-left: 4px;
    width: 1196px;
    height: 2px;
    background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, rgba(147, 172, 255, 0.5) 50%, rgba(255, 255, 255, 0) 100%);
  }
  #md0btm {
    margin: 53px 112px 116px 77px;
    width: 1011px;
  }
  #md1 {
    background: #EEF6FF;
    position: relative;
    overflow: hidden;
    height: 660px;
  }
  #md1bg0 {
    position: absolute;
    top: 54px;
    /* left: 120px; */
    display: block;
    width:91px;
  }
  #md1bg1 {
    position: absolute;
    display: block;
    right: 0px;
  }
  .md1fr {
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(49, 70, 104, 0.3);
    border-radius: 6px;
  }
  #md1c0 {
    width: 347px;
    display: inline-block;
    margin: 33px 0 111px 133px;
  }
  .md1cfr {
    display: inline-block;
    float:left;
    position: absolute;
    margin-top: 62px;
    overflow: hidden;
  }
  #md1c1 {
    display: inline-block;
    width: 347px;
    float:left;
  }
  #md1c2 {
    display: inline-block;
    width: 340px;
    margin-top: 26px;/*39*/
    margin-left: 16px;
  }
  #md1c3 {
    width: 571px;
    margin-top: 16px;
  }
  #md1tt {
    width: 442px;
    height: 100px;
    font-size: 34px;
    font-weight: bold;
    color: #000000;
    margin-left: 55px;
    margin-top: 23px;
  }
  #md1st {
    width: 400px;
    height: 25px;
    font-size: 22px;
    font-weight: 300;
    color: #000000;
    margin-left: 55px;
    margin-top: 8px;
  }
  .md1fr div:nth-child(1) {
    padding: 26px 30px 30px 30px;
  }
  .md1fr div:nth-child(2) {
    font-size: 24px;
    font-weight: 800;
    color: #000000;
    margin-top: 8px;
  }
  .md1fr img:nth-child(2) {
    margin-top: 8px;
  }
  .md1imgsz {
    width: 48px;;
  }
  .md1fr label {
    display: block;
    font-size: 18px;
    font-weight: 300;
    color: #494949;
    margin-top: 16px;
  }
  #md2 {
    background: #0C1028;
    position: relative;
    overflow: hidden;
    text-align: center;
  }
  #md2 img {
    display: block;
    margin: 64px auto 64px auto;
    width: 1032px;
  }
  #md3 {
    background: #EEF6FF;
    position: relative;
    overflow: hidden;
    text-align: center;
    padding: 62px 0 62px 0;
  }
  #md3 div:nth-child(1) {
    font-size: 48px;
    font-weight: 400;
    color: #000000;
  }
  #md3 label {
    font-weight: bold;
  }
  #md3 div:nth-child(2) {
    width: 1000px;
    font-size: 24px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.8);
    margin: 32px auto 28px auto;
  }
  #md4 {
    background: #0C1028;
    position: relative;
    overflow: hidden;
    text-align: center;
    padding: 80px 0 77px 0;
  }
  #md4 div:nth-child(1) {
    font-size: 48px;
    font-weight: 800;
    color: #FFFFFF;
  }
  #md4 div:nth-child(2) {
    width: 1010px;
    font-size: 24px;
    font-weight: 400;
    color: #FFFFFF;
    margin: 32px auto 0px auto;/* 53 */
  }
  #md4 img {
    display: block;
    margin: 53px auto 0 auto;
  }
  #md5 {
    background: #EEF6FF;
    position: relative;
    overflow: hidden;
    padding: 40px 0 40px 0;
  }
  #md5a {
    width: 940px;
    display: inline-block;
    float: left;
  }
  #md5att {
    width: 600px;
    font-size: 48px;
    font-weight: bold;
    color: #000000;
    margin-top: 40px;
  }
  #md5ast {
    font-size: 24px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.8);
    margin-top: 16px;
  }
  /* #md5apl {
    width: 908px;
    height: 466px;
    margin-top: 40px;
  } */
  #md5apl {
    width: 908px;
    margin-top: 40px;
  }
  /* #md5adesc {
    font-size: 24px;
    font-weight: 500;
    color: #111437;
  } */
  #md5adesc {
    font-size: 24px;
    font-weight: 500;
    width: 700px;
    color: #111437;
    position:absolute;
    top: 687px;
  }
  .el-carousel__item img {
    width: 100%;
  }
  ul {
    text-align: right !important;
  }
  ul button {
    background-color: #3454FF !important;
    width: 40px !important;
    height: 6px !important;
    margin-top: 23px !important;
  }
  /* .el-carousel__item:nth-child(2n+1) {
    background-color: #99a9bf;
  }  */

  .md5plid {
    display: inline-block;
    width: 40px;
    height: 6px;
    margin-right: 16px;
    background: rgba(186, 196, 255, 0.6);
    cursor: pointer;
  }
  .md5plidsl {
    display: inline-block;
    width: 40px;
    height: 6px;
    margin-right: 16px;
    background: #3454FF;
    cursor: pointer;
  }
  #md5b {
    width: 260px;
    height: 770px;
    display: inline-block;
    float: left;
    overflow: hidden;
    background: linear-gradient(180deg, #0D1765 0%, #0C1028 100%);
    border-radius: 8px;
  }
  #md6 {
    background: #0C1028;
    position: relative;
    overflow: hidden;
    text-align: center;
  }
  #md6bg {
    position: absolute;
    display: block;
    margin-left: 494px;
    width: 692px;
  }
  #md6a {
    position: relative;
    height: 504px;
    text-align: left;
    /* background: cyan; */
    overflow: hidden;
  }
  #md6a div {
    margin: 189px 0 0 0px;
    font-size: 40px;
    width: 500px;
    font-weight: 800;
    color: #FFFFFF;
  }
  #md6a label {
    margin: 16px 0 0 0px;
    width: 500px;
    font-size: 20px;
    font-weight: 400;
    color: #FFFFFF;
    display: block;
  }
  #md6b {
    background: none;
    overflow: hidden;
    position: relative;
  }
  .md6bfr {
    display: inline-block;
    width: 342px;
    overflow: hidden;
    float: left;
    text-align: left;

  }
  .md6bimgsz {
    width: 342px;
    position: relative;
  }
  .md6bidsz {
    width: 70px;
  }
  .md6bfr div {
    font-size: 28px;
    font-weight: 800;
    color: #FFFFFF;
  }
  .md6bfr label {
    display: block;
    width: 280px;
    font-size: 22px;
    font-weight: 300;
    color: #D6DBE8;
    margin-top: 16px;
  }
  .md6bfr:nth-child(2),.md6bfr:nth-child(4) {
    width: 70px;
    margin-top: 154px;
  }
  #md6c {
    margin-top: 50px;
    padding-bottom: 40px;
  }
  #md6clg0 {
    width: 381px;
  }
  #md6cdesc {
    font-size: 22px;
    font-weight: bold;
    color: #FFFFFF;
    letter-spacing: 10px;
    margin-top:19px;
  }
  #md6carr {
    font-size: 16px;
    font-weight: 300;
    color: #D6DBE8;
  }
  #md6cct {
    padding: 0 0 30px 0;
    position: relative;
  }
  #md6cct div,img {
    display: inline-block;
  }
  #md6cct div {
    float: right;
    margin-top: 11px;
  }
  #md6cct img {
    /* float: left;     */
    margin-left: -13px;
    width: 347px;
  }
  #md6cct label {
    display: block;
    font-size: 18px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 27px;

  }
  #md6d {
    background: #000000;
    padding: 36px 0 40px 0;
  }
  /* enfix */
  .enfs16 {
    font-size: 16px !important;
  }
  .enfs20 {
    font-size: 20px !important;
  }
  .enfs22 {
    font-size: 22px !important;
  }
  .enw380 {
    width: 380px !important;
  }
  .enw308 {
    width: 308px !important;
  }
  .enw608 {
    width: 608px !important;
  }
  .enmt8 {
    margin-top: 8px !important;
  }
  .enml0 {
    letter-spacing: 0px !important;
  }
  .pd22 {
    padding-left: 22px;
  }

</style>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import en from '@/components/en.js'
import cn from '@/components/cn.js'
import HomePhone from '@/views/Home_p.vue'
export default {
  name: "Home",
  components: {
    HomePhone
  },
  computed: {

    lang () {
      return localStorage.lang
    },
    iscn () {
      return this.lang == 'cn'
    },
    md5awds () {
      return [
        this.lan.md5d0,this.lan.md5d1,this.lan.md5d2
      ]
    },
    md5bs () {
      return this.iscn? [
        require('../assets/md5v0.png'),
        require('../assets/md5v1.png'),
        require('../assets/md5v2.png'),
        require('../assets/md5v3.png'),
        require('../assets/md5v4.png'),
        require('../assets/md5v5.png'),
        require('../assets/md5v6.png'),
        require('../assets/md5v7.png')
      ] : [
        require('../assets/md5v0_en.png'),
        require('../assets/md5v1_en.png'),
        require('../assets/md5v2_en.png'),
        require('../assets/md5v3_en.png'),
        require('../assets/md5v4_en.png'),
        require('../assets/md5v5_en.png'),
        require('../assets/md5v6_en.png'),
        require('../assets/md5v7_en.png')
      ]
    }
  },
  data() {
    return {
      isphone: false,
      lan: {},
      loading: false,
      logo: require('../assets/logo.png'),
      logo_en: require('../assets/logo_en.png'),
      m0bg: require('../assets/m0bg.png'),
      pc: require('../assets/pc.png'),
      md0desc: require('../assets/md0desc.png'),
      md0desc_en: require('../assets/md0desc_en.png'),
      md1bg0: require('../assets/md1bg0.png'),
      md1bg1: require('../assets/md1bg1.png'),
      md1i0: require('../assets/md1i0.png'),
      md1i1: require('../assets/md1i1.png'),
      md1i2: require('../assets/md1i2.png'),
      md1i3: require('../assets/md1i3.png'),
      md1ib: require('../assets/md1ib.png'),
      md2img: require('../assets/md2img.png'),
      md2img_en: require('../assets/md2img_en.png'),
      md3img: require('../assets/md3img.png'),
      md4img0: require('../assets/md4img0.png'),
      md4img1: require('../assets/md4img1.png'),
      md4img1_en: require('../assets/md4img1_en.png'),
      md6abg: require('../assets/md6abg.png'),
      md6abg_en: require('../assets/md6abg_en.png'),
      md6bid0: require('../assets/md6bid0.png'),
      md6bid1: require('../assets/md6bid1.png'),
      md6b0: require('../assets/md6b0.png'),
      md6b1: require('../assets/md6b1.png'),
      md6b2: require('../assets/md6b2.png'),
      md6cbg: require('../assets/md6cbg.png'),
      langic: require('../assets/lang.png'),
      md6cbg1: require('../assets/md6cbg1.png'),
      md0ien: require('../assets/md0ien.png'),
      md0icn: require('../assets/md0icn.png'),
      md0lanck: require('../assets/md0lanck.png'),
      md5as: [
        require('../assets/md50.png'),
        require('../assets/md51.png'),
        require('../assets/md52.png')
      ],
      md5asl: 0,
      tpmg: 0
    };
  },
  methods: {
    cardChange (index) {
      this.md5asl = index
    },

    md5bPlay () {
      var _this = this
      setInterval(() => {
        if (_this.tpmg < 1470) { //700
          _this.tpmg += 3
        } else {
          _this.tpmg = 0
        }
      }, 100);
    },
    changLang (lang) {
      localStorage.lang = lang
      location.reload(true)
    },
    getList() {
      this.loading = true;
      this.$getList(
        this.page,
        this.rows,
        (res) => {
          this.loading = false;
          if (res.code == 0) {
            this.tableData = res.data;
            this.total = res.total;
          } else {
            this.$message.error(res.msg);
          }
        },
        () => {
          this.loading = false;
        }
      );
    },
  },
  mounted() {
    if (!this.lang) {
      if (navigator.language == 'zh-cn' || navigator.language == 'zh-CN') {
        localStorage.lang = 'cn'
        this.lan = cn
      } else {
        localStorage.lang = 'en'
        this.lan = en
      }
    } else {
      this.lan = this.iscn?cn:en
    }

    try {
        if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
          this.isphone = true
        } else {
          this.isphone = false
          this.md5bPlay()
          setTimeout(() => {
            var mvp = document.getElementById('testViewport');
            mvp.setAttribute('content','width=1280');
          }, 500);
        }
    } catch (e) {}

  },
};
</script>
